import { useEffect, useState } from "react";

export default function useZoneId() {
  const [zoneId, setZoneId] = useState("");

  useEffect(() => {
    setZoneId(/^\w+/.exec(window.location.hostname)?.[0] ?? "");
  }, []);
  return zoneId;
}
